// extracted by mini-css-extract-plugin
module.exports = {"image-wrapper":"CarouselItem_image-wrapper__HzsWj","image":"CarouselItem_image___tYdI","title":"CarouselItem_title__LoEFn","subtitle":"CarouselItem_subtitle__V83NH"};